import { Colors } from '../consts/Colors.js';
import ButtonMenu from '../prefabs/global/buttons/ButtonMenu.js';
import LoginPanel from '../prefabs/menu/LoginPanel.js';
import NewGamePanel from '../prefabs/menu/NewGamePanel.js';
import SauvegardeManager from '../prefabs/SauvegardeManager.js';
import SoundManager from '../prefabs/SoundManager.js';
import AbstractScene from './AbstractScene.js';


export default class Menu extends AbstractScene {
    constructor() {
        super({
            key: "Menu"
        })
    }
    init(data) {
        this._init(data);

        this.sauvegardeManager = new SauvegardeManager()
    }

    preload() {
        this._preload();

        this.menuGroup = this.add.group();

        this.soundManager = new SoundManager();
        this.soundManager.stopAllLoops()
        this.soundManager.playAudio('Intro');
    }

    create(){
        // Ajout du fond
        this.background = this.add.image(-229, -157, 'menu_background').setOrigin(0, 0);

        // Ajout du titre   
        let titre = this.add.image(822, 211, 'menu_titre').setOrigin(0)
        this.menuGroup.add(titre)

        // Ajout du logo
        const logo = this.add.image(202, 907, 'logo_CVC')

        // Ajout des boutons
        const loginButton = new ButtonMenu(this, 1124, 745, {
            text: "COMPTE\nCONNEXION",
            icon: 'icon_perso',
            color: Colors.Elmt.Black,
            hoverColor: Colors.Elmt.DarkGrey,
            borderColor: Colors.Elmt.DarkGrey
        })
        loginButton.setClickFunction( () => {
            this.displayPanel(this.loginPanel)
        })
        this.menuGroup.add(loginButton)

        const startButton = new ButtonMenu(this, 1428, 745, {
            text: "NOUVELLE\nPARTIE",
            icon: 'icon_etoiles',
            color: Colors.Elmt.Orange,
            hoverColor: Colors.Elmt.Blue,
            borderColor: Colors.Elmt.White
        })

        startButton.setClickFunction( () => {
            this.displayPanel(this.newGamePanel)
        } );

        this.menuGroup.add(startButton)

        this.loginPanel = new LoginPanel(this, this.width, 0, () => {this.hidePanel()})
        this.newGamePanel = new NewGamePanel(this, this.width, 0, () => {this.hidePanel()})
        this.panel = null
    }

    displayPanel(panel){
        this.panel = panel;
        // Cache élements du menu
        this.tweens.add({
            targets: this.menuGroup.getChildren(),
            alpha: 0,
            duration: 500,
            onComplete: () => {
                this.menuGroup.setVisible(false);
            }
        })

        // Affiche le panneau de login
        this.tweens.add({
            targets: this.panel,
            x: 875,
            duration: 500,
            ease: 'Cubic.easeInOut',
        })
    }

    hidePanel(){
        // Cache le panneau de login
        this.tweens.add({
            targets: this.panel,
            x: this.width,
            duration: 500,
            ease: 'Cubic.easeInOut',
        })

        // Affiche élements du menu
        this.menuGroup.setVisible(true);
        this.tweens.add({
            targets: this.menuGroup.getChildren(),
            alpha: 1,
            duration: 500,
        })
    }
}